import React, { useState } from 'react';
import { Button } from '@janus.team/janus-particles';
import { Mask } from './Mask';
import ArrowUpRightFromSquare from '@rss-engineering/fabric-assets/dist/icons/ArrowUpRightFromSquare';
import { REGIONS } from './constants';

const renderDetailValue = (detailsLabel, detailsValue, loading, musked, viewAPIKey) => {
  const APIKey = 'API Key';
  
  if (loading) {
    return <div className="rsd-skeleton__placeholder rsd-skeleton">Loading...</div>;
  }
  
  if ([APIKey, 'Docs Link', 'Select Region'].indexOf(detailsLabel) < 0 && detailsValue) {
    return <div>{detailsValue}</div>;
  }
  
  if (detailsLabel === 'Docs Link') {
    return <a rel="noreferrer" href={detailsValue} target="_blank">{detailsValue}</a>;
  }
  
  if (detailsLabel === 'Select Region') {
    return (
      <div>
        {REGIONS.map((region) => (
          <div key={region.name} className="mb-2">
            <a 
              href={region.url} 
              target="_blank" 
              rel="noreferrer" 
              className="d-inline-flex align-items-center gap-2"
              style={{ cursor: 'pointer' }}
            >
              {region.name} <ArrowUpRightFromSquare size={16} />
            </a>
          </div>
        ))}
      </div>
    );
  }
  
  if (detailsLabel === APIKey && detailsValue) {
    return (
      <div>
        <Mask value={detailsValue} masked={musked} length={detailsValue?.length} />
        <Button
          as="button"
          onClick={viewAPIKey}
          tertiary
        >
          {musked ? 'View' : 'Hide' }
        </Button>
      </div>
    );
  }
  
  return null;
};

export const KeyValueView = ({ detailsMap, resetAPIKey, isAdmin }) => {
  const [musked, setMusked] = useState(true);

  const viewAPIKey = () => {
    setMusked(!musked);
  };

  const detailsMapView = Object.keys(detailsMap)?.map((key) => {
    const detailsLabel = detailsMap[key]?.key;
    const detailsValue = detailsMap[key].value;
    const APIKey = 'API Key';
    
    return (
      <div key={detailsLabel}>
        <div className="detailsKey">
          {detailsLabel} &nbsp;
          {detailsLabel === APIKey && isAdmin && (
            <Button
              as="button"
              onClick={resetAPIKey}
              tertiary
            >
              Reset
            </Button>
          )}
        </div>
        <div className="detailsValue">
          {renderDetailValue(detailsLabel, detailsValue, detailsMap[key].loading, musked, viewAPIKey)}
        </div>
      </div>
    );
  });

  return (
    <div className="detailsGrid">
      { detailsMapView }
    </div>
  );
};
